import { useContext } from 'react';
import { PedidosContext } from 'contexts/carrinho-context';

export const usePedidosContext = () => {
  const props = useContext(PedidosContext);
  return props;
};
